<script setup lang="ts">
import { computed } from 'vue'
import { useShipStore } from '@/stores/shipStore'
import { useGameStore } from '@/stores/gameStore'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'

/**
 * Props
 */
const props = defineProps({
  shipId: {
    type: Number,
    required: true
  }
})

/**
 * Stores
 */
const shipStore = useShipStore()
const gameStore = useGameStore()

/**
 * Variables / Refs
 */
// Add your reactive variables here

/**
 * Computed
 */
const shipData = computed(() => shipStore.findShipById(props.shipId)!)

// Enhanced action display logic
const actionDisplayText = computed(() => {
  if (shipData.value.currentActionName === 'Repairing' && shipData.value.actions.length > 0) {
    const repairAction = shipData.value.actions.find(action => action.action === 'repair')
    if (repairAction?.targetDay) {
      const daysRemaining = repairAction.targetDay - gameStore.turn
      if (daysRemaining <= 0) {
        return 'Repair completed'
      }
      return `Repairing (${daysRemaining}d left)`
    }
  }
  return shipData.value.currentActionName
})

/**
 * Methods
 */
// Add your methods here

/**
 * Lifecycle hooks
 */
// Add lifecycle hooks if needed (onMounted, onUnmounted, etc.)
</script>

<template>
  <div>
    {{ actionDisplayText }}
    <span
      v-if="shipData.defendActionSet === 1 && shipData.currentActionName !== 'Defend'"
      class="pl-1"
    >
      <GenericIcon type="shield" tooltip="Defend" />
    </span>
    <span v-if="shipData.actions.length > 1" class="pl-1">
      {{ shipData.actions.length > 1 ? '+' + (shipData.actions.length - 1) : '' }}
    </span>
  </div>
</template>

<style scoped lang="scss">
// Add your component-specific styles here
</style>
